import { z } from 'zod';

export const AddressSchema = z.object({
  id: z.uuid().optional(),
  text: z.string().nullish(),
  addressLine1: z.string().min(1).nullish(),
  addressLine2: z.string().nullish(),
  addressLine3: z.string().nullish(),
  city: z.string().min(1).nullish(),
  county: z.string().nullish(),
  postalCode: z.string().min(1).nullish(),
  country: z.string().nullish(),
  countryCode: z.string().nullish(),
  geoLocation: z
    .object({
      lat: z.string().optional().nullish(),
      lng: z.string().optional().nullish(),
    })
    .optional()
    .nullish(),
  summary: z.string().nullish(),
  timeZone: z.string().nullish(),
});

export const AddressGeoLocationSchema = z.object({
  lat: z.string().nullish(),
  lng: z.string().nullish(),
});

export const CommonAddressSchema = z.object({
  id: z.string().nullish(),
  addressLine1: z.string().nullish(),
  addressLine2: z.string().nullish(),
  addressLine3: z.string().nullish(),
  addressLine4: z.string().nullish(),
  addressLine5: z.string().nullish(),
  postalCode: z.string().nullish(),
  country: z.string().nullish(),
  countryCode: z.string().nullish(),
  timeZone: z.string().nullish(),
  geoLocation: AddressGeoLocationSchema.nullish(),
});

export type AddressModel = z.infer<typeof AddressSchema>;
export type CommonAddressModel = z.infer<typeof CommonAddressSchema>;
